import { SentimentName } from 'v2/core/entities/fields';

const mapSentimentNameString = (sentiment: string): SentimentName => {
  switch (sentiment) {
    case 'Negative':
      return SentimentName.NEGATIVE;
    case 'Neutral':
      return SentimentName.NEUTRAL;
    case 'Positive':
      return SentimentName.POSITIVE;
    default:
      throw Error('unknown sentiment ' + sentiment);
  }
};

export { mapSentimentNameString };
